export default __webpack_public_path__ + "static/media/bateria1tom.1ba59f5d.png";